import { BasketStatus } from 'graphql-api/baskets-api-interfaces';

export const basketStatusesLocale: { [key in BasketStatus]?: string } = {
  [BasketStatus.New]: $localize`:CBasket|Basket status new label@@basketStatusNew:New`,
  [BasketStatus.Failed]: $localize`:CBasket|Basket status failed label@@basketStatusFailed:Failed`,
  [BasketStatus.Processed]: $localize`:CBasket|Basket status processed label@@basketStatusProcessed:Processed`,
  [BasketStatus.Processing]: $localize`:CBasket|Basket status processing label@@basketStatusProcessing:Processing`,
  [BasketStatus.Submitted]: $localize`:CBasket|Basket status submitted label@@basketStatusSubmitted:Submitted`,
  [BasketStatus.Pending]: $localize`:CBasket|Basket status pending label@@basketStatusPending:Pending`,
  [BasketStatus.Rejected]: $localize`:CBasket|Basket status rejected label@@basketStatusRejected:Rejected`,
};
